export default __webpack_public_path__ + "static/patient-brochure-desktop-e5d1ffb1ba02bbad0ad193b71d4a78b4.png";